interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ kicker, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-3xl mx-auto" : "max-w-2xl"}>
      <div
        className={`flex items-center gap-3 mb-4 ${
          isCenter ? "justify-center" : "justify-start"
        }`}
      >
        <span className="w-8 h-px bg-primary-500" />
        <span className="font-label text-xs tracking-[0.28em] uppercase text-primary-600">
          {kicker}
        </span>
      </div>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}